<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FBI0A1/tc-custom/9781466812819.jpg?1737766217233" alt="This image is the cover for the book Moving Targets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moving Targets
      </h1>
      <p class="bookDescription body article font2">
        <b>“A genuine blockbuster . . . With this novel, Sean Flannery takes his rightful place along such masters as Tom Clancy and Clive Cussler.” —Ed Gorman, <i>Mystery Scene</i></b><br/><br/>The Cold War is over—followed by a deadlier menace than the world has ever known. Its codename: Operation Homeward Bound. Deep within the KGB, a dedicated fraternity conspires to restore the power of its fragmented homeland. Brutal, power-crazed, ruthlessly efficient, these renegade agents want nothing less than the destruction of the US.<br/><br/>To insure its mission, this sinister coterie will use every weapon available. Torture. Murder. Even the family of a US security adviser.<br/><br/><b>“Not only do Flannery’s spy thrillers have the ring of truth; sometimes they <i>become</i> the truth. Let’s hope <i>Moving Targets</i> remains fiction.” —Dean Ing, <i>New York Times</i>–bestselling author</b><br/><br/><b>“Full of intriguing, fully drawn characters from both sides of the old cold war . . . [A] clever and thoroughly believable painting of interagency warfare, diverted loyalties, and political confusion in our time. Quite good.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Flannery
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f10a18d